import React, {Component} from 'react';

export default class Audience extends Component{
    render(){

        return (
            <div>{this.props.children}</div>
        )
    }
}
